import type { FaireProductEntity } from "../../entity_types/product";

export const p_h9gjma7fgq: FaireProductEntity = {
  token: "p_h9gjma7fgq",
  type: "product",
  name: "Nerve Pain Rollerball Travel Size",
  brandToken: "b_63rejl12p8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4efff76713037cfc6008b6a1cc96241e94c13b653a5979a46b22afafb5ea0fe4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a0e02a1848bdff1514437acf9e27de9fa89e0342591707242bc52ab6f84f05d.png",
    "https://cdn.faire.com/fastly/e4832b42c90f6e9c41fba5f8196342c1c902d932aeb97dd0eb9a6d2bf4a48afa.png",
    "https://cdn.faire.com/fastly/36e49ec664280e53d2a52c9c837742ed899287f7c94f23df1c3cefbfd051beae.png",
    "https://cdn.faire.com/fastly/492c2760a7ee4698d06b1c228e47ec05f4abbdd3e177887391f84317d557cac9.jpeg",
    "https://cdn.faire.com/fastly/fb025d8ff6ab114de73476a7f71ad2157ac11a1a6df43c26df130d1f691f95d9.jpeg",
    "https://cdn.faire.com/fastly/27b4d1b2cd8e50cbc3b5df7f48e8b90e3a00381065020c32c89aa17cab375824.png",
    "https://cdn.faire.com/fastly/e0c9bfe2cd1cdaa1b866e50480bb7fd92ff94ca99ed1ea39920b35b35be4c49f.png",
    "https://cdn.faire.com/fastly/89663dd7bf79435b8e9348b4e321c1596d1cdb6a556311bacf3115b1ea9d1ea9.png",
  ],
  priceDollars: 7.59,
  description:
    "Forces of Nature Nerve Pain Management is designed to provide fast-acting neuropathy relief. If you’re experiencing burning, tingling, and shooting discomfort, this is a powerful blend of certified organic homeopathic medicines, including Coffea Cruda (Green Coffee) praised for its potent anti-inflammatory properties and Hypericum Perforatum (St. John’s Wort) known as a nervine tonic. These active ingredients are blended with pure essential oils, including Roman and German Chamomile, for soothing, deep penetration. Unlike common OTC pain relievers that often mask symptoms with capsaicin or menthol, our clean, plant-based medicine works with your body to calm sensitivity and restore comfort.\n\nCertified Organic, Non-GMO Project Verified, and Leaping Bunny certified, Nerve Pain Management sets a higher standard for pain management. Make this your choice for natural relief that is tough on pain but gentle on the body and safe for everyday use.\n\nLimited availability only in our original packaging. Product size will be discontinued after January 2026. See also our larger 11ml size.\n",
  tags: [],
  msrpDollars: 15.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:47.632Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
